// Move sticky button to body to fix positioning
document.addEventListener('DOMContentLoaded', function() {
  const visibleButton = document.querySelector('.hc_cta_visible');
  const stickyButton = document.querySelector('.hc_cta_sticky');
  
  if (visibleButton && stickyButton) {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    if (width < 900) {
      // Mobile: Move sticky button and set up intersection observer
      const parentElement = stickyButton.parentElement;
      parentElement.removeChild(stickyButton);
      document.body.appendChild(stickyButton);
      
      // Set mobile styles
      stickyButton.style.visibility = "hidden";
      stickyButton.style.position = 'fixed';
      stickyButton.style.bottom = '0';
      stickyButton.style.left = '0';
      stickyButton.style.width = '100%';
      stickyButton.style.margin = '0';
      stickyButton.style.padding = '15px';
      stickyButton.style.borderRadius = '0';
      stickyButton.style.background = '#E62A2A';
      stickyButton.style.height = '5rem';
      stickyButton.style.zIndex = '9999';
      stickyButton.style.display = 'flex';
      stickyButton.style.justifyContent = 'center';
      stickyButton.style.alignItems = 'center';
      stickyButton.style.color = 'white';
      stickyButton.style.textDecoration = 'none';
      stickyButton.style.textAlign = 'center';
      stickyButton.style.boxSizing = 'border-box';
      stickyButton.style.transform = 'none';
      
      // Set up intersection observer for mobile
      const observer = new IntersectionObserver(
        function(entries) {
          if (entries[0].isIntersecting) {
            stickyButton.style.visibility = "hidden";
          } else {
            stickyButton.style.visibility = "visible";
          }
        },
        { threshold: 0 }
      );
      
      observer.observe(visibleButton);
      
    } else {
      // Desktop: Hide the sticky button completely
      stickyButton.style.display = 'none';
    }
  } else {
    console.error("Could not find hc_cta_visible or hc_cta_sticky elements");
  }
});